import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardBunnyColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="8 8 170 170" {...props}>
      <path
        d="m115.484 22.293 1.848.719c2.137 6.375.867 13.797 0 20.351l1.555-.879c9.949-5.304 20.687-8.75 31.336-12.394l2.797-1.012c2.984-.894 4.875-.637 7.87.125 1.356 1.356 1.06 2.578 1.09 4.461-.054 4.297-1.011 7.813-2.535 11.805l-.734 1.972c-4.836 12.657-11.738 23.704-24.488 29.555q-4.236 1.567-8.559 2.863c-2.047.48-2.047.48-2.996 1.563l.11 2.598c.07 3.703-.989 6.843-2.126 10.34-.757 2.445-1.207 4.878-1.543 7.413l3.114-.386c4.39-.024 6.527 2 9.632 4.883 2.747 3.16 3.504 5.554 3.477 9.718l.016 2.301c-.239 2.07-.239 2.07-2.016 4.727h-2.664l.043 2.449c.043 3.008.078 6.02.101 9.027q.022 1.952.055 3.903c.035 1.875.047 3.746.059 5.62l.043 3.415c-.34 3.382-.785 4.843-2.969 7.445-2.379.45-4.203.59-6.582.543l-2.023.016q-3.316.01-6.633-.032-2.31-.006-4.614 0-4.84-.006-9.68-.047c-4.128-.035-8.253-.039-12.382-.035-3.176.004-6.356-.007-9.531-.02a890 890 0 0 0-4.567-.01q-3.194-.002-6.394-.044l-1.89.008c-4.09-.07-6.903-.879-10.372-3.035a533 533 0 0 1-3.125-4.063c-1.68-1.586-3.156-2-5.375-2.629-2.734-.797-3.965-1.293-6.223-3.152-1.78-3.555-2.117-6.617-1.277-10.512 1.941-2.437 3.441-3.925 6.223-5.308 2.375-.118 4.734-.04 7.113 0l.664-2.325c2.566-6.894 7.43-11.246 12.668-16.261l-2.445-1.492c-3.633-2.575-5.914-4.891-7.332-9.125C53.02 87 56.89 78.008 63.109 69.914l1.114-1.512c2.738-3.535 5.82-5.836 9.554-8.222h1.778l.554-2.157c4.157-10.718 13.016-17.34 21.86-24.218q2.857-2.25 5.644-4.582l3.332-2.727 1.578-1.348c3.786-3.062 3.786-3.062 6.961-2.855"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#2e2d2f",
          fillOpacity: 1,
        }}
      />
      <path
        d="M158.223 32.746c-2.461 11.535-5.887 23.149-14.223 31.86l-1.766 1.898c-6.472 6.348-14.949 9.863-24.011 10.492l.093 2.266c.168 6.976.137 12.468-4.207 18.238-2.863 2.2-5.511 2.21-9 2.285l-1.875.078q-2.285.089-4.566.14l-.89 2.657-1.883.07-2.45.153-2.437.12-2.117.544-1.782 3.539h-8l1.782-2.656c.148-2.325.148-2.325 0-4.426l-1.782-.883-.332 2.102c-.554 2.324-.554 2.324-2.332 4.093-1.832.235-1.832.235-3.945.22l-2.11.015c-1.945-.235-1.945-.235-4.613-2.004l1.391-1.11 1.277-1.546c-.203-1.914-.203-1.914-.89-3.54l-1.778 1.77a79 79 0 0 1-5.332.883c-2.55-3.805-2.191-7.04-1.777-11.504 2.004-9.902 7.906-18 16-23.895 9.863-5.882 19.32-5.046 30.223-2.656l.851-1.492c9.332-15.191 26.637-19.969 42.676-25.316a72 72 0 0 0 4.324-1.688c1.926-.707 1.926-.707 5.48-.707"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#f5c96f",
          fillOpacity: 1,
        }}
      />
      <path
        d="m94.723 105.262 3.054.054v3.54h21.332v-3.54h6.223c0 3.54 0 3.54-1.777 6.196-.325 3.578-.325 3.578 0 7.078l1.336 1.46c1.843 2.88 1.664 5.513 1.593 8.813l-.011 1.73c-.012 2.122-.051 4.239-.082 6.36l-.168 14.383H96l-2.668-6.195-2.664-1.77c-.363-2.402-.121-4.64 0-7.082l2.074-.129 2.703-.203c.887-.062 1.774-.121 2.688-.184 2.449-.16 2.449-.16 4.09-2.136.054-2.63.054-2.63-.891-5.313-1.937-1.926-1.937-1.926-4.387-3.37l-2.414-1.567c-2.008-1.246-2.008-1.246-3.863-2.14q-.036-3.738-.055-7.47l-.023-2.152c-.008-1.809.031-3.617.078-5.426.887-.883.887-.883 4.055-.937"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#b9d6fc",
          fillOpacity: 1,
        }}
      />
      <path
        d="M87.11 110.625v7.078l-2.665.887c1.375 4.113 5.2 5.488 8.797 7.61 5.207 3.167 5.207 3.167 6.313 6.55-9.164.883-14.426-3.266-21.332-8.852h-1.778v2.657c1.914 1.672 1.914 1.672 4.332 3.207l2.438 1.64c2.023 1.34 2.023 1.34 3.894 2.235v8.847H80l-.723-3.37c-.535-2.067-.988-3.602-2.109-5.423-2.484-1.449-5.008-1.562-7.836-1.828v1.774l2.059.718c3.648 1.606 3.648 1.606 5.054 3.704.485 2.375.688 4.66.887 7.082l2.434.129 3.18.203c1.038.062 2.081.125 3.156.183 2.789.367 2.789.367 5.453 2.14l-.887 3.54a1313 1313 0 0 1-13 .195q-2.209.024-4.418.07a483 483 0 0 1-6.367.079l-1.98.054c-4.59.004-7.141-1.07-10.68-3.937-3.094-4.29-2.301-10.05-1.778-15.047 2.371-9.305 8-15.598 15.11-21.793 6.011-2.742 13.168-1.074 19.554-.332"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#f4c86f",
          fillOpacity: 1,
        }}
      />
      <path
        d="M152 40.71c-1.04 9.353-7.027 18.688-13.902 24.958-6.606 5.02-15 8.754-23.43 7.785-2.617-2.016-2.68-3.601-3.223-6.855.188-4.082 2-6.297 4.825-9.137 8.414-7.352 24.41-16.75 35.73-16.75"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#ea9e43",
          fillOpacity: 1,
        }}
      />
      <path
        d="M113.777 27.434c.344 10.14-.554 18.796-7.222 26.828l-1.95 2.367-1.496 1.781-2.144-.437c-3.871-.543-7.617-.543-11.52-.504l-2.242.011q-2.712.02-5.426.043c2.793-9.945 12.809-15.816 20.715-21.847 2.977-2.29 5.883-4.668 8.805-7.035 1.594-1.207 1.594-1.207 2.48-1.207"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#eba94b",
          fillOpacity: 1,
        }}
      />
      <path
        d="M97.777 72.57c.555 1.66.555 1.66.891 3.54l-1.777 1.769c-.473 1.832-.473 1.832-.782 3.871-.718 3.54-1.566 5.406-4.554 7.637-2.547 1.265-4.774 1-7.61.992l-3.172.008c-2.55-.117-2.55-.117-3.441-1-.574-3.797-.852-7.395 1.129-10.785 2.852-3.325 4.57-5.02 9.074-5.426q1.841-.115 3.688-.219l1.902-.117c1.55-.09 3.102-.184 4.652-.27"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#2b2a2b",
          fillOpacity: 1,
        }}
      />
      <path
        d="m150.223 42.48-2.797 1.364c-16.715 7.074-16.715 7.074-28.317 19.875-.199 3.18.094 5.789.891 8.851-.89.883-.89.883-3 1.16-2.332-.277-2.332-.277-3.945-1.601-1.524-3.195-1.895-5.895-1.055-9.293 5.387-9.293 16.328-13.594 25.723-17.7l2.488-1.1 2.367-1.005 2.125-.902c2.211-.602 3.383-.395 5.52.351"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#d6833a",
          fillOpacity: 1,
        }}
      />
      <path
        d="M101.332 61.95c-3.34 1.1-6.402.82-9.887.663-7.562-.156-12.593 1.887-18.336 6.696l-2 2.375-1.32 1.511c-6.75 8.188-8.164 16.41-7.566 26.809l-2.668-.883c-2.16-4.3-1.246-10.137.113-14.605 3.684-9.625 9.566-17.309 18.887-22.067 7.449-3.199 15.14-3.265 22.777-.5"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#efe4b1",
          fillOpacity: 1,
        }}
      />
      <path
        d="M74.668 126.555c4.559 1.742 9.031 3.492 12.441 7.082.68 3.058.496 5.77 0 8.847H80l-.723-3.37c-.718-2.837-1.222-4.641-3.722-6.364-1.868-1.04-1.868-1.04-3.555-1.77Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e29942",
          fillOpacity: 1,
        }}
      />
      <path
        d="M158.223 32.746v1.77l-3.266 1.105a1064 1064 0 0 0-14.512 5.09l-2.414.86c-13.324 4.808-24.094 10.046-32.254 22.148l-3.554-.883 2.668-.887c1.175-1.617 1.175-1.617 2.277-3.594 8.977-13.757 26.453-18.28 41.25-23.214a72 72 0 0 0 4.324-1.688c1.926-.707 1.926-.707 5.48-.707"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#ece0ad",
          fillOpacity: 1,
        }}
      />
      <path
        d="M73.777 110.625a964 964 0 0 1-3.886 3.098l-2.188 1.742c-1.926 1.355-1.926 1.355-3.703 1.355l-.719 1.496c-1.55 2.996-3.394 5.801-5.203 8.649-2.226 4.2-2.219 8.23-2.246 12.922l-.035 3.238c.191 2.71.547 4.176 1.98 6.441-2.07-.828-3.304-1.39-4.539-3.277-2.355-6.027-1.297-13.11.93-19.016 3.062-6.543 11.11-19.335 19.61-16.648"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#ede1ad",
          fillOpacity: 1,
        }}
      />
      <path
        d="m112.89 27.434.887 2.656a1695 1695 0 0 1-5 4.258c-.515.437-1.03.879-1.562 1.328a257 257 0 0 1-9.899 7.914c-5.507 4.195-10.304 8.496-14.648 13.933l-.89-1.77c5.202-8.495 12.878-14.058 20.679-20.046a556 556 0 0 0 6.766-5.34l2.16-1.726Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#eec26b",
          fillOpacity: 1,
        }}
      />
      <path
        d="M48.89 130.094v11.508c-5.335 0-5.335 0-7-1.497-1.203-2.457-1.476-3.77-1-6.468 2.637-3.602 3.266-3.543 8-3.543"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#ebc26f",
          fillOpacity: 1,
        }}
      />
      <path
        d="M97.777 115.05h21.332v3.54H97.777Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#4689f6",
          fillOpacity: 1,
        }}
      />
      <path
        d="M97.777 141.602h21.332v2.652H97.777Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#3b82f6",
          fillOpacity: 1,
        }}
      />
      <path
        d="m94.723 105.262 3.054.054v2.653h-4.445v14.16l-2.664-.883q-.036-3.737-.055-7.469l-.023-2.152c-.008-1.809.031-3.617.078-5.426.887-.883.887-.883 4.055-.937"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#f6f7f8",
          fillOpacity: 1,
        }}
      />
      <path
        d="M158.223 32.746v1.77q-4.167 1.47-8.332 2.93l-2.348.827a296 296 0 0 1-15.988 5.09l-1.778-1.77 1.809-.62q4.065-1.401 8.137-2.809l2.84-.977 2.753-.953 2.524-.867a83 83 0 0 0 4.687-1.844c2.141-.777 2.141-.777 5.696-.777"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e1d6a6",
          fillOpacity: 1,
        }}
      />
      <path
        d="M104 123.898h15.11l.89 2.657h-16Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#3e84f6",
          fillOpacity: 1,
        }}
      />
      <path
        d="M101.332 61.95c-3.348 1.1-6.45.85-9.941.718-5.704-.125-10.047.746-14.946 3.707.258-1.672.258-1.672.887-3.54 7.5-3.944 16.125-3.737 24-.886"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e7dba7",
          fillOpacity: 1,
        }}
      />
      <path
        d="M128 110.625c2.668.887 2.668.887 3.555 2.656.035 1.77.039 3.54 0 5.309-1.664.555-1.664.555-3.555.887-1.777-1.774-1.777-1.774-2-4.426.223-2.656.223-2.656 2-4.426"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e7c77d",
          fillOpacity: 1,
        }}
      />
      <path
        d="M105.777 132.75h13.332v2.656h-13.332Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#3c83f6",
          fillOpacity: 1,
        }}
      />
      <path
        d="M48.89 130.094v1.77l-2.167.831c-2.18.73-2.18.73-3.168 1.825-.262 3.292-.13 4.23 1.777 7.082-1.719-.5-1.719-.5-3.555-1.774-.886-2.984-.886-2.984-.886-6.191 2.246-3.36 4.027-3.98 8-3.543"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#d8cea1",
          fillOpacity: 1,
        }}
      />
      <path
        d="M88 76.996c1.488.25 2.973.547 4.445.883l-.89 3.543-3.555.883a77 77 0 0 1-.89-4.426Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#dfdfe0",
          fillOpacity: 1,
        }}
      />
      <path
        d="M78.223 123.016c3.25 1.21 6.183 2.664 9.168 4.425l2.375 1.383 1.789 1.27v1.77c-3.168-1.16-5.864-2.552-8.664-4.423l-2.098-1.382c-1.684-1.274-1.684-1.274-2.57-3.043"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e4d7a5",
          fillOpacity: 1,
        }}
      />
      <path
        d="M90.668 136.29h2.664v7.964l-2.664-.883Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#f9f9f9",
          fillOpacity: 1,
        }}
      />
      <path
        d="M119.11 105.316h6.222l.89 2.653h-7.113Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#e2e7ed",
          fillOpacity: 1,
        }}
      />
      <path
        d="m70.223 109.738 3.554.887-8 5.309c1.778-4.422 1.778-4.422 4.446-6.196"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "#f1e5b0",
          fillOpacity: 1,
        }}
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClipboardBunnyColored);
export default ForwardRef;
